<template>
    <div>
        <div :class="['onboarding-container checkbox-container row visible-on col-sm-5 col-md-8 col-lg-5 col-sm-offset-3 col-md-offset-1 col-lg-offset-4', align === 'left' ? 'align-left' : 'align-center']">
            <div class="checkbox" @click="select"><img v-if="internalValue === '1'" :src="checkboxSelect" alt=""></div>
            <span @click="selectOrLink">{{ this.text }}</span>
            <onboarding-modal v-if="modal" v-show="showPolicy" v-model="showPolicy" :title="modal['title']" :body="modal['body']"></onboarding-modal>
        </div>
        <div v-if="internalErrorMessage" class="col-xs-12 col-sm-5 col-md-8 col-lg-5 col-sm-offset-3 col-md-offset-1 col-lg-offset-4 error-text error-message">{{ this.internalErrorMessage }}</div>
    </div>
</template>
<script>
import OnboardingModal from '@/components/onboarding/form/Modal'
import { onboardingMixin } from './mixin.js'
// @text: the text content.
// @value: whether this field is selected.
// @link: open the link when clicking it.
// @isRequired: whether this field can be empty.
// @modal: open the modal when clicking it.(follow the Modal component) e.g.: {title: '', body: ''}

export default {
  props: ['text', 'value', 'link', 'isRequired', 'modal', 'align'],
  mixins: [onboardingMixin],
  components: {
    OnboardingModal
  },
  data () {
    return {
      checkboxSelect: require('@/assets/image/onboarding/common/checkbox-selected.png'),
      internalValue: '',
      showPolicy: false,
      internalErrorMessage: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    this.internalValue = this.value
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('change', val)
    },
    '$i18n.locale' (val) {
      this.validate()
    }
  },
  methods: {
    validate () {
      if (this.fieldIsRequired(this.isRequired) && this.internalValue !== '1') {
        this.internalErrorMessage = this.isRequiredMessage
        return false
      }
      return true
    },
    select () {
      this.internalValue = this.internalValue === '0' ? '1' : '0'
      if (this.internalValue === '1') {
        this.internalErrorMessage = ''
      }
    },
    selectOrLink () {
      if (this.link && !this.modal) {
        let link = this.link
        if (!link.startsWith('http')) {
          link = `http://${link}`
        }
        window.open(link)
        return
      }
      if (this.modal) {
        this.showPolicy = true
        return
      }
      this.select()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
.align-left {
    justify-content: flex-start;
}
.align-center {
    justify-content: center;
}
.checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    .checkbox {
        border: solid 1px black;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 15px;
        height: 15px;
        img {
            user-select: none;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    span {
        margin-left: 15px;
        cursor: pointer;
        user-select: none;
    }
}

.error-message {
    padding-left: 10px;
}

</style>
